import React, { Component } from 'react'
import SocialButton from '../SocialButton'
import facebookIcon from '../../images/facebook.svg'
import constants from '../../constants'

export default class FacebookRegistrationButton extends Component {
  handleSocialLogin = (user) => {
    const { onChange, onChooseMethod } = this.props

    const { firstName, lastName, email } = user.profile

    let fetchedParams = {
      password: true,
      passwordConfirmation: true
    }

    if(firstName) {
      onChange("firstName", firstName)
      fetchedParams["firstName"] = true
    }

    if(lastName) {
      onChange("lastName", lastName)
      fetchedParams["lastName"] = true
    }

    if(email) {
      onChange("email", email)
      fetchedParams["email"] = true
    }

    onChange("facebookToken", user.token.accessToken)
    onChange("facebookId", user.profile.id)
    onChange("fetchedParams", fetchedParams)
    onChange("step", "facebook")

    onChooseMethod && onChooseMethod()
  }

  handleSocialLoginFailure = (err) => {
    this.setState({errors: {base: "Unable to register with Facebook"}})
  }

  render() {
    const { loading, errors } = this.props

    return (
      <div>
        { errors.base && <div className="base-errors">{ errors.base }</div> }
        <SocialButton
          provider="facebook"
          appId={constants.facebookAppId}
          onLoginSuccess={this.handleSocialLogin}
          onLoginFailure={this.handleSocialLoginFailure}
          disabled={loading}
          className="login__with__facebook"
          >
          <span><img alt="Login using Facebook" src={facebookIcon} className="login__with__facebook__icon" /></span>
          <span className="login__with__facebook__text">Register with Facebook</span>
        </SocialButton>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SignupWidget/FacebookRegistrationButton.js